import { Phone } from 'lucide-react';
import { CONTACT, buildWhatsappLink } from '@/constants/site';
import { FLOATING } from '@/constants/testIds';

// Official WhatsApp brand glyph
const WhatsappBrand = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="white" aria-hidden>
    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.71.306 1.264.489 1.696.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.414z" />
  </svg>
);

export default function FloatingContact() {
  const waHref = buildWhatsappLink();
  return (
    <div className="fixed right-4 md:right-6 bottom-6 md:bottom-8 z-50 flex flex-col items-end gap-3">
      {/* WhatsApp — visible on all viewports, official green */}
      <a
        href={waHref}
        target="_blank"
        rel="noreferrer"
        data-testid={FLOATING.whatsapp}
        aria-label="Chat on WhatsApp"
        onClick={() => window.gtag && window.gtag('event', 'Whatsapp', { source: 'floating' })}
        className="relative flex items-center justify-center rounded-full w-14 h-14 bg-[#25D366] text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.55)] hover:scale-105 hover:shadow-[0_14px_40px_-8px_rgba(37,211,102,0.75)] transition-all duration-300 group"
      >
        <WhatsappBrand size={30} />
        <span className="hidden md:inline-flex absolute right-[68px] top-1/2 -translate-y-1/2 whitespace-nowrap bg-[hsl(var(--bb-ivory))] text-[hsl(var(--bb-text))] text-[10px] tracking-[0.22em] uppercase font-medium px-3 py-2 border border-[hsl(var(--bb-text))]/15 opacity-0 -translate-x-1 pointer-events-none transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0">
          WhatsApp
        </span>
        <span className="absolute -top-0.5 -right-0.5 w-3 h-3 bg-[#25D366] rounded-full animate-ping opacity-60" />
      </a>

      {/* Call — MOBILE ONLY */}
      <a
        href={`tel:${CONTACT.phoneRaw}`}
        data-testid={FLOATING.call}
        aria-label="Call us"
        className="md:hidden relative flex items-center justify-center rounded-full w-14 h-14 bg-[hsl(var(--bb-gold))] text-[hsl(var(--bb-charcoal))] shadow-[0_10px_30px_-8px_rgba(0,0,0,0.5)] hover:scale-105 transition-transform duration-300"
      >
        <Phone size={22} strokeWidth={2.2} />
      </a>
    </div>
  );
}
